import { Box, Stack, type StackProps, Typography, useTheme } from "@mui/material";

interface IStateMessageProps extends StackProps {
  image?: React.JSX.Element;
  message?: string;
  smallSize?: boolean;
  secondaryMessage?: string;
}

export const StateMessage = (props: IStateMessageProps) => {
  const theme = useTheme();
  const { image, message, secondaryMessage, smallSize, children, ...rest } = props;
  return (
    <Stack
      spacing={2}
      sx={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
      {...rest}
    >
      {image && (
        <Box
          sx={() => ({
            svg: {
              color: theme.palette.primary.main,
              fontSize: theme.typography.pxToRem(smallSize ? 75 : 150),
            },
          })}
        >
          {image}
        </Box>
      )}
      <Box>
        {message && (
          <Typography variant={"h6"} sx={{ color: theme.palette.primary.main }}>
            {message}
          </Typography>
        )}
        {secondaryMessage && (
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              textAlign: "center",
              lineHeight: 1.5,
            }}
          >
            {secondaryMessage}
          </Typography>
        )}
      </Box>
      {children}
    </Stack>
  );
};
